<template>
  <m-input-percentage
    v-bind="$attrs"
    :value="base100Value"
    v-on="listeners"
    @input="handleInput"
  />
</template>

<script>
  import { MInputPercentage } from 'codefabrik-gui-vue'

  export default {
    name: 'PercentageInput',
    components: { MInputPercentage },
    props: {
      value: {
        type: Number,
        default: 0
      }
    },
    computed: {
      base100Value () {
        return this.value * 100
      },
      listeners () {
        const { input, ...rest } = this.$listeners
        return rest
      }
    },
    methods: {
      handleInput (value) {
        this.$emit('input', value / 100)
      }
    },
  }
</script>

<style scoped>

</style>
